import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdFilterList, MdAddCircle, MdEdit, MdDelete } from "react-icons/md";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import loading from "../../../assets/images/common/loading.gif";
import AppDataGrid from "../../../components/common/AppDataGrid";

const GroupMaster = () => {
    const [groupmasters, setGroupmaster] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const [isLoading, setIsLoading] = useState(true);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = sessionStorage.getItem("user");
    const userObj = userData ? JSON.parse(userData) : {};
    const [grouptypes, setGrouptype] = useState([]);

    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "School Admin"];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());

    const [form, setForm] = useState({
        route_location_id: "",
        location_name: "",

        school_id: userObj?.school_id || ""
    });

    const [filter, setFilter] = useState({
        parent_description: "",
        description: "",
        group_code: "",
        group_type_id: "",
        parentgroup_master_id: "",


        action: "FILTER"
    });

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };

    useEffect(() => {
        GroupType();


    }, []);

    const GroupType = async () => {
        try {
            const response = await axios.get(baseUrl + "/getgrouptypes/", {
                action: "READ",
                // school_id: userObj.school_id
            });

            setGrouptype(response.data.group_types || []);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const fetchGroupmaster = async () => {
        try {
            const response = await axios.get(`${baseUrl}/getallgroupmaster/`);

            // Extract the array properly
            const data = Array.isArray(response.data.group_master)
                ? response.data.group_master
                : [];

            setGroupmaster(data);
        } catch (error) {
            console.error("Error fetching group masters:", error);
            setGroupmaster([]);
        }
    };



    // const handleFilterSearch = async () => {
    //     try {
    //         const response = await axios.post(`${baseUrl}/routelocation/`, {
    //             action: "FILTER",
    //             school_id: userObj.school_id,
    //             ...filter
    //         });
    //         setRoutes(response.data);
    //         setShowFilterModal(false);
    //     } catch (error) {
    //         console.error("Error filtering route locations:", error);
    //     }
    // };

    const handleFilterSearch = async (e) => {
        e.preventDefault();

        const cleanVal = (v) => {
            if (v === "" || v === " " || v === null || v === undefined) return null;
            return v;
        };

        const formData = {
            group_code: cleanVal(filter.group_code),
            description: cleanVal(filter.description),
            parentgroup_master_id: filter.parentgroup_master_id ? Number(filter.parentgroup_master_id) : null,
            group_type_id: filter.group_type_id ? Number(filter.group_type_id) : null,
            school_id: userObj.school_id,
            action: "FILTER",
        };

        try {
            const response = await axios.post(baseUrl + "/groupmasterfilter/", formData, {
                headers: { "Content-Type": "application/json" },
            });

            setGroupmaster(response.data || []);
            handleCloseFilterModal();
        } catch (error) {
            console.error("ERR:", error);
        }
    };




    const handleEditClick = (group_master_id) => {
        const selected = groupmasters.find(r => r.group_master_id === group_master_id);
        if (selected) {
            navigate("/finance/groups/add", { state: { GroupData: selected } });
        } else {
            console.error(`Route Location ID ${group_master_id} not found`);
        }
    };

    const handleDeleteClick = async (group_master_id) => {
        if (!window.confirm("Are you sure you want to change the status?")) return;

        try {
            await axios.post(`${baseUrl}/groupmasterdelete/`, {
                action: "DELETE",
                group_master_id,
                modified_by: "admin"

            });
            toast.success("Record Set To InActive");
            // fetchRouteLocations();
            fetchGroupmaster();

        } catch (error) {
            console.error("Error deleting route location:", error);
        }
    };

    const searchableColumns = [
        (row) => row.group_type_name,
        (row) => row.group_code,
        (row) => row.description,
        (row) => row.parent_description,


    ];

    const filteredRecords = (groupmasters || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const columns = [
         {
            field: "group_type_name",
            headerName: "Group Type",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            )
        },
          {
            field: "parent_description",
            headerName: "Parent Group",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            )
        },
       
        {
            field: "description",
            headerName: "Sub Group Name",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            )
        },
      
        {
            field: "group_code",
            headerName: "Sub Group",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            )
        },
        {
            field: "is_active",
            headerName: "Is Active",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            )
        },
        ...(canSubmit
            ? [
                {
                    field: "actions",
                    headerName: "Actions",
                    flex: 1,
                    sortable: false,
                    renderCell: (params) =>
                        params.row.group_master_id !== "No records found" ? (
                            <div className="tableActions">
                                <Tooltip title="Edit" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleEditClick(params.row.group_master_id)}
                                    >
                                        <MdEdit />
                                    </span>
                                </Tooltip>
                                <Tooltip title="Delete" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleDeleteClick(params.row.group_master_id)}
                                    >
                                        <MdDelete />
                                    </span>
                                </Tooltip>
                            </div>
                        ) : null
                }
            ]
            : [])
    ];

    const handleReset = async (e) => {
        e.preventDefault();
        setFilter({
            group_type_id: "",
            pl_group_code: "",
            group_code: "",
            description: "",
            // last_level: false,
            // status: "A",
            // school_id: userObj?.school_id || ""
        });
        setShowFilterModal(true);
        // fetchRouteLocations();
        fetchGroupmaster();
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    useEffect(() => {
        setIsLoading(true);
        fetchGroupmaster().finally(() => setIsLoading(false));

    }, []);

    return (
        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Group Master</h6>
                    </div>
                    <div>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                            <Button className="primaryBtn" variant="primary" onClick={() => navigate("/finance/groups/add")}>
                                <MdAddCircle />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={filteredRecords}
                            columns={columns}
                            getRowId={(r) => r.group_master_id}
                            showToolbar={false}
                            pagination
                            pageSizeOptions={[10, 20, 50]}
                            density="compact"
                            maxHeight={500}
                        />
                    )}
                </div>
            </div>

            {/* Filter Modal */}
            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group controlId="group_code">
                                    <Form.Label>Sub Group</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="group_code"
                                        value={filter.group_code}
                                        placeholder="Enter Sub Group"
                                        onChange={(e) => setFilter({ ...filter, group_code: e.target.value })}
                                    />
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group controlId="description">
                                    <Form.Label>Sub Group Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="description"
                                        value={filter.description}
                                        placeholder="Enter Sub Group Name"
                                        onChange={(e) => setFilter({ ...filter, description: e.target.value })}
                                    />
                                </Form.Group>
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>Group Type</Form.Label>
                                    <Form.Select
                                        name="group_type_id"
                                        id="group_type_id"
                                        value={filter.group_type_id}
                                        onChange={(e) => setFilter({ ...filter, group_type_id: e.target.value })}>
                                        <option value="" disabled hidden>Select Group Type</option>
                                        {(grouptypes || [])
                                            // .filter((level) => level.is_active === "Active")
                                            .map((grouptypes) => (
                                                <option key={grouptypes.group_type_id} value={grouptypes.group_type_id}>
                                                    {grouptypes.group_type_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>
                        {/* <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group controlId="status">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="status"
                                        value={filter.status}
                                        placeholder="Enter Status"
                                        onChange={(e) => setFilter({ ...filter, status: e.target.value })}
                                    />
                                </Form.Group>
                            </div>
                        </Col> */}
                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={handleCloseFilterModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            className="btn-success primaryBtn"
                            onClick={handleFilterSearch}
                        >
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default GroupMaster;
